export const MAIL_APP_NAME = 'mail';
export const CALENDAR_APP_NAME = 'calendar';
export const FILES_APP_NAME = 'files';
export const PEOPLE_APP_NAME = 'people';
